import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-calendar-setup",
    prompt: (guidanceItem) => `Your ${guidanceItem.parameters.planShortName} plan requires a payroll calendar so we can accurately report when funds should post to employees' accounts.`,
    details: (guidanceItem) => getDetails(guidanceItem),
    openAction: {
        text: "Where to set up payroll calendar(s)?",
        url: (guidanceItem) => getOpenUrl(guidanceItem)
    },
    completeAction: {
    },
});

function getOpenUrl(guidanceItem) {
    if (guidanceItem.parameters && guidanceItem.parameters.orderEffectiveDate) {
        let date = moment(guidanceItem.parameters.orderEffectiveDate).format('MM-DD-YYYY');
        return `/employer/${guidanceItem.employerId}/calendars?orderEffectiveDate=${date}`;
    } else {
        return `/employer/${guidanceItem.employerId}/calendars`;
    }
}

function getDetails(guidanceItem) {
    if (guidanceItem.parameters && guidanceItem.parameters.employerHasExistingCalendar) {
        var details = `To assign a plan to an existing calendar, click the three dots on the right-hand side of the Calendars window, select <strong>Assign Plans</strong>, then enter ${guidanceItem.parameters.planType}. `;
        if (guidanceItem.parameters.employerHasMultipleCalendars) details += " Remember to do this for each calendar which may be used by your plan.";
        return details;
    } else {
        return `To add a new calendar, click the three dots on the right-hand side of the Calendars window then select New Calendar. Select the dates on which funds will be posted to employees' accounts. Click Save.`;
    }
}



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-calendar-setup.js